import classNames from 'classnames'
import React from 'react'

interface SubmitButtonProps {
  text: string
  onSubmit: () => void
  disabled?: boolean
  loadText?: string
  loading?: boolean
  className?: string
}

const SubmitButton = ({
  text,
  loadText,
  onSubmit,
  disabled = false,
  loading = false,
  className = 'btn btn-primary mt-8'
}: SubmitButtonProps) => {
  const buttonText = loading ? (loadText ? loadText : 'Loading...') : text
  return (
    <button
      className={classNames({
        [className]: true,
        'btn-disabled': disabled || loading
      })}
      onClick={e => {
        e.preventDefault()
        onSubmit()
      }}
    >
      {buttonText}
    </button>
  )
}

export default SubmitButton
